import { Map } from 'immutable';
import { actionTypes as EditDashboardDemoDataDialogActionsType } from '../../../actions/Administration/PsManagementPage/Dialogs/editDashboardDemoDataDialogActions.js';

let defaultState = {
  show: false,
  loading: false,
  itemToEdit: null,
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case EditDashboardDemoDataDialogActionsType.EDIT_DASHBOARD_DEMO_DATA_DIALOG_SHOW:
      state = state.set('itemToEdit', action.payload);
      return state.set('show',true);

    case EditDashboardDemoDataDialogActionsType.EDIT_DASHBOARD_DEMO_DATA_DIALOG_HIDE:
      return Map(defaultState);

    case EditDashboardDemoDataDialogActionsType.EDIT_DASHBOARD_DEMO_DATA_DIALOG_SUBMIT_IN_PROGRESS:
      return state.set('loading', true);

    case EditDashboardDemoDataDialogActionsType.EDIT_DASHBOARD_DEMO_DATA_DIALOG_SUBMIT_FINISHED:
      return state.set('loading', false);

    default:
      return state;
  }

}







